import {
  IntegrationFilter,
  CallType,
  LeadStatus,
} from '@callrail/inti/src/inti/proto/integration_filter';
import { nullifyValues } from './helpers';

/**
 * By default our integration filter endpoints return a standardized Protobuf
 * response. However until the frontend can be updated to parse this response,
 * we need to provide it with the legacy response it is has historically
 * expected from the CallRail app.
 *
 * The entire purpose of this class is to transform a `IntegrationFilter` protobuf object
 * into the same format generated by the CallRail application's
 * `criteria#show` endpoint
 *
 * See: https://github.com/callrail/callrail/blob/master/app/controllers/integrations/integration_criteria_controller.rb#L45
 *
 */
export function legacyTransformListIntegrationFilter(
  integration_filter: IntegrationFilter
) {
  return nullifyValues({
    call_type: CallType[integration_filter.callType]?.toLowerCase(),
    company_id: null, // we aren't returning this data, hmm, and even if we did, it is the masked_id
    id: integration_filter.id,
    integration_id: integration_filter.integrationId,
    min_duration: integration_filter.minDuration,
    max_duration: integration_filter.maxDuration,
    tracker_ids: integration_filter.trackerMids, // the tracker_ids looky needs _are_ masked_ids
    tags: integration_filter.tagIds.map((id) => {
      return { id };
    }),
    lead_status: LeadStatus[integration_filter.leadStatus]?.toLowerCase(),
  });
}
